import sessionServices from 'admin/services/session'
import services from 'admin/services'

export const PAGINATE = 'admin/PAGINATE'
export const SEARCH = 'admin/SEARCH'
export const FILTER = 'admin/FILTER'
export const RESET_FILTER = 'admin/RESET_FILTER'
export const SORT = 'admin/SORT'
export const TOGGLE_SELECTION = 'admin/TOGGLE_SELECTION'
export const PERSON_EDIT_TOGGLE = 'admin/PERSON_EDIT_TOGGLE'
export const RESET_SELECTION = 'admin/RESET_SELECTION'
export const SET_SELECTION = 'admin/SET_SELECTION'
export const RESET_LISTING = 'admin/RESET_LISTING'
export const ATS_DEMO_REQUEST = 'ATS_DEMO_REQUEST'
export const SET_NEW_INVITEES = 'SET_NEW_INVITEES'
export const JOYRIDE_STEPS_ADD = 'JOYRIDE_STEPS_ADD'
export const JOYRIDE_INTERACTION = 'JOYRIDE_INTERACTION'
export const JOYRIDE_RESET = 'JOYRIDE_RESET'
export const UPDATE_USER_LOCATION = 'UPDATE_USER_LOCATION'
export const VIDEO_EDIT = 'VIDEO_EDIT'
export const VIDEO_UPDATED = 'VIDEO_UPDATED'

export const paginate = payload => ({ type: PAGINATE, payload })

export const search = payload => ({ type: SEARCH, payload })

export const filter = payload => ({ type: FILTER, payload })

export const resetFilter = payload => ({ type: RESET_FILTER, payload })

export const sort = payload => ({ type: SORT, payload })

export const toggleSelection = payload => ({ type: TOGGLE_SELECTION, payload })

export const resetSelection = payload => ({ type: RESET_SELECTION, payload })

export const setSelection = payload => ({ type: SET_SELECTION, payload })

export const resetListing = payload => ({ type: RESET_LISTING, payload })

export const joyrideInteraction = payload => ({ type: JOYRIDE_INTERACTION, payload })

export const resetJoyride = payload => ({ type: JOYRIDE_RESET, payload })

export const setNewInvitees = payload => ({ type: SET_NEW_INVITEES, payload })

export const requestDemo = type => (
  () => sessionServices.requestDemo(type)
)

export const togglePersonEdit = payload => ({ type: PERSON_EDIT_TOGGLE, payload })

export const updateUserLocation = payload => ({ type: UPDATE_USER_LOCATION, payload })

export const videoEdit = payload => ({ type: VIDEO_EDIT, payload })

export const videoUpdated = payload => ({ type: VIDEO_UPDATED, payload })

export const updateVideo = ({
  title,
  tags,
  selectedLibrary,
  videoId,
}) => dispatch => services.updateVideo({
  title,
  tags,
  selectedLibrary,
  videoId,
})
  .then((res) => dispatch(videoUpdated({ ...res, selectedLibrary })))
